import { formatDecimal } from '../ui/numbers';

/** People's settlements (F39) as the API sends them. Amounts are missing for whoever may not see them. */
export const SETTLEMENTS_RESOURCE = 'settlements.settlements';
export const OVERTIME_RESOURCE = 'settlements.overtime';
export const SETTLEMENTS_SETTINGS_RESOURCE = 'settlements.settings';
export const SETTLEMENTS_KEY = ['settlements'] as const;

export type SettlementState = 'otwarte' | 'zatwierdzone' | 'wyplacone';
export const STATES: Record<SettlementState, string> = { otwarte: 'Otwarte', zatwierdzone: 'Zatwierdzone', wyplacone: 'Wypłacone' };
export type ItemKind = 'dniowka' | 'nadgodziny' | 'wydatek' | 'reczna' | 'potracenie';
export const KINDS: Record<ItemKind, string> = { dniowka: 'Dniówka', nadgodziny: 'Nadgodziny', wydatek: 'Wydatek', reczna: 'Pozycja ręczna', potracenie: 'Potrącenie' };
export const METHODS = { przelew: 'Przelew', gotowka: 'Gotówka' } as const;

export type Item = {
  id: string;
  kind: ItemKind;
  description: string;
  daysMilli: number;
  hoursMilli: number;
  multiplierBp: number;
  rateGrosze?: number;
  amountGrosze?: number;
  receiptFileId: string | null;
  auto: boolean;
  version: number;
};
export type Payout = { id: string; method: keyof typeof METHODS; amountGrosze?: number; paidOn: string; note: string };
export type Settlement = {
  id: string;
  eventId: string;
  personId: string;
  personName: string;
  eventName: string;
  eventFirstDay: string;
  state: SettlementState;
  items: Item[];
  payouts: Payout[];
  totalGrosze?: number;
  paidGrosze?: number;
  /** F44: "Umowa: <numer>". */
  contractId: string | null;
  contractNumber: string | null;
  version: number;
};
export type SummaryRow = {
  settlementId: string;
  eventId: string;
  eventName: string;
  eventFirstDay: string;
  personId: string;
  personName: string;
  state: SettlementState;
  totalGrosze?: number;
  paidGrosze?: number;
  dueGrosze?: number;
};
export type Summary = { rows: SummaryRow[]; totals?: { totalGrosze: number; paidGrosze: number; dueGrosze: number } };
export type Overtime = { id: string; personId: string; personName: string; hoursMilli: number; multiplierBp: number; description: string; version: number };
export type OvertimeList = { overtime: Overtime[]; people: Array<{ personId: string; personName: string }> };

/** 2000 → '2', 3500 → '3,5'. */
export const hoursLabel = (milli: number): string => formatDecimal(milli / 1000);
/** 15000 → '1,5', 20000 → '2'. */
export const multiplierLabel = (bp: number): string => formatDecimal(bp / 10000);
/** '2026-09-12' → '12.09.2026'. */
export const dayLabel = (day: string): string => `${day.slice(8, 10)}.${day.slice(5, 7)}.${day.slice(0, 4)}`;
export const settlementKey = (id: string) => [...SETTLEMENTS_KEY, 'one', id] as const;
export const eventSettlementsKey = (eventId: string) => [...SETTLEMENTS_KEY, 'event', eventId] as const;
